import React, { useEffect, useState } from "react"
import { FormControl, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { checkFurnitureInRoom } from "../../../Services/Generate";
import { ProcessMultiImageServ } from "../../../Services/Enhance";

const RoomStaging: React.FunctionComponent<{ image: any, onEnhancedImage: any, onChangeMessagehandler?: any }> = (props) => {

    const [category, setCategory] = useState<any>("residential");
    const [selectRoom, setSelectRoom] = useState<any>("");
    const [selectStyle, setSelectStyle] = useState<any>("");
    const [hasFurniture, setHasFurniture] = useState<boolean>(false);
    const [isCheckingFurniture, setIsCheckingFurniture] = useState<boolean>(true);
    const [isRemovingFurniture, setIsRemovingFurniture] = useState<boolean>(false);
    const [currentImage, setCurrentImage] = useState<any>(Array.isArray(props.image) ? props.image[0] : props.image);
    const { t } = useTranslation();

    useEffect(() => {
        const checkForFurniture = async () => {
            if (!currentImage || !currentImage.src) return;
            setIsCheckingFurniture(true);
            const imageObj = {
                id: currentImage.id,
                src: currentImage.src,
                ext: currentImage.ext
            };
            checkFurnitureInRoom(imageObj).then((resp) => {

                // Handle different response structures
                let resultArray = [];

                if (Array.isArray(resp)) {
                    resultArray = resp;
                } else if (resp && typeof resp === 'object') {
                    // If response is an object, try common property names
                    resultArray = resp.images || resp.data || resp.result || resp.items || [];
                }

                // Check if any item has type "furnished-room"
                if (Array.isArray(resultArray) && resultArray.length > 0) {
                    const hasFurnishedRoom = resultArray.some((item: any) => item.type === "furnished-room");
                    setHasFurniture(hasFurnishedRoom);
                } else {
                    setHasFurniture(false);
                }

                setIsCheckingFurniture(false);

            }).catch((error) => {
                setHasFurniture(false);
                setIsCheckingFurniture(false);
                console.error("Error checking furniture:", error);
            });
        };

        checkForFurniture();
    }, [currentImage.id]);

    const handleRemoveFurniture = async () => {
        setIsRemovingFurniture(true);
        try {
            const imageObj = {
                processid: window.location.pathname.includes('Enhance-Generate') ? sessionStorage.getItem('processid-enhance') : sessionStorage.getItem('processid'),
                images: [currentImage],
                url: "Remove Furniture Staging",
                data: "",
            };

            const result = await ProcessMultiImageServ(imageObj);
            console.log("Remove furniture result:", result);

            // Handle different response structures
            if (result) {
                let newImageSrc = null;

                // Try different possible response structures
                if (result.image) {
                    newImageSrc = result.image.src || result.image;
                } else if (result.images && Array.isArray(result.images) && result.images.length > 0) {
                    newImageSrc = result.images[0].src || result.images[0];
                } else if (result.src) {
                    newImageSrc = result.src;
                } else if (typeof result === 'string') {
                    newImageSrc = result;
                }

                if (newImageSrc) {
                    // Update the current image with the furniture-removed version
                    const updatedImage = {
                        ...currentImage,
                        src: newImageSrc,
                    };
                    setCurrentImage(updatedImage);
                    setHasFurniture(false);
                    console.log("Image updated successfully:", newImageSrc);
                } else {
                    props.onChangeMessagehandler("Could not find updated image in response.", true, "error");
                    console.error("Could not find image in response:", result);
                }
            }
        } catch (error: any) {
            if (error?.response?.status === 401) {
                props.onChangeMessagehandler(error.response.data.message, true, "error");
            } else {
                props.onChangeMessagehandler("Error removing furniture", true, "error");
            }
        } finally {
            setIsRemovingFurniture(false);
        }
    }

    const handleSelectChangeRoom = (event: any) => {
        setSelectRoom(event.target.value);
    }

    const handleSelectChangeStyle = (event: any) => {
        setSelectStyle(event.target.value);
    }

    const handleChangeCategory = (value: any) => {
        setCategory(value)
    }

    const generate = () => {
        const generateObj = {
            "category": category,
            "room_type": selectRoom,
            "style": selectStyle,
            "images": [{
                "id": currentImage.id,
                "src": currentImage.src,
                "ext": currentImage.ext
            }]
        }
        props.onEnhancedImage(generateObj);
    };


    return (
        <div className="card-F1F5F9 ">
            <div className=" padd-30">
                <div className="room-staging-image-preview">
                    <div className="room-staging-image-container">
                        <img
                            src={currentImage && currentImage.src}
                            alt="Room preview"
                            className={`room-staging-image ${isRemovingFurniture ? 'room-staging-image-loading' : ''}`}
                        />
                        {/* Spinner overlay for removing furniture */}
                        {isRemovingFurniture && (
                            <div className="room-staging-spinner-overlay">
                                <div className="spinner-border" style={{ color: '#4f52c1', width: '40px', height: '40px' }} role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <span style={{ color: '#4f52c1', fontSize: '14px', fontWeight: '600' }}>
                                    Removing furniture...
                                </span>
                            </div>
                        )}
                        {/* Spinner overlay for checking furniture */}
                        {isCheckingFurniture && (
                            <div className="room-staging-spinner-overlay-simple">
                                <div className="spinner-border text-primary size-20" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Alert Messages */}
                    {!isCheckingFurniture && hasFurniture && (
                        <div className="room-staging-alert">
                            <div className="room-staging-alert-content">
                                <div className="room-staging-alert-icon">
                                    <svg width="20" height="20" fill="white" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                    </svg>
                                </div>
                                <span className="room-staging-alert-text">
                                    This Room is furnished, please remove the furniture to achieve better results.
                                </span>
                            </div>
                            <button
                                type="button"
                                onClick={handleRemoveFurniture}
                                disabled={isRemovingFurniture}
                                className="room-staging-btn-remove"
                            >
                                {isRemovingFurniture ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Removing...
                                    </>
                                ) : (
                                    'Remove Furniture'
                                )}
                            </button>
                        </div>
                    )}
                </div>

                <label className="form-label bold-700 mb-2 padd-00" htmlFor="selectTypeOpt">Category</label>
                <div className="btn-group environment mb-3"  style={{gridTemplateColumns: "1fr 1fr", display: "grid"}} id="environment">
                    <button type="button" className={`btn ${category === "residential" ? "active" : ""}`} onClick={() => handleChangeCategory("residential")} >
                        Residential
                    </button>
                    <button type="button" className={`btn ${category === "commercial" ? "active" : ""}`} onClick={() => handleChangeCategory("commercial")} >
                        Commercial
                    </button>
                </div>
                {category === "residential" && <div className="row">
                    <div className="col-md-6">
                        <label className="form-label bold-700 mb-3 padd-00" htmlFor="selectTypeOpt">{t("roomImageGeneration.selectRoomType")}</label>
                        <FormControl fullWidth>
                            <Select
                                className="custom-select mb-4"
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectRoom}
                                onChange={handleSelectChangeRoom}
                                sx={{
                                    border: "1px solid #BEBDBD",

                                }}>
                                <MenuItem key={0} value="" disabled>
                                    {t("propertiesPage.select")}
                                </MenuItem>
                                <MenuItem key={1} value={"Bedroom"}>{t("roomImageGeneration.bedroom")}</MenuItem>
                                <MenuItem key={2} value={"Bathroom"}>{t("roomImageGeneration.bathroom")}</MenuItem>
                                <MenuItem key={3} value={"Living Room"}>{t("roomImageGeneration.livingRoom")}</MenuItem>
                                <MenuItem key={4} value={"Kitchen"}>{t("roomImageGeneration.kitchen")}</MenuItem>
                                <MenuItem key={5} value={"Balcony"}>{t("roomImageGeneration.balcony")}</MenuItem>
                                <MenuItem key={6} value={"Office Room"}>{t("roomImageGeneration.officeRoom")}</MenuItem>
                                <MenuItem key={7} value={"Dining Area"}>{t("roomImageGeneration.diningArea")}</MenuItem>
                                <MenuItem key={8} value={"Terrace"}>{t("roomImageGeneration.terrace")}</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label bold-700 mb-3 padd-00" htmlFor="selectTypeOpt">{t("roomImageGeneration.selectFurnishingStyle")}</label>
                        <FormControl fullWidth>
                            <Select
                                className="custom-select mb-4 "
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectStyle}
                                onChange={handleSelectChangeStyle}
                                sx={{
                                    border: "1px solid #BEBDBD",
                                }}>
                                <MenuItem key={0} value="" disabled> {t("propertiesPage.select")} </MenuItem>
                                <MenuItem key={1} value={"Eclectic"}>{t("roomImageGeneration.eclectic")}</MenuItem>
                                <MenuItem key={2} value={"Cottage"}>{t("roomImageGeneration.cottage")}</MenuItem>
                                <MenuItem key={3} value={"Scandinavian"}>{t("roomImageGeneration.scandinavian")}</MenuItem>
                                <MenuItem key={4} value={"Coastal"}>{t("roomImageGeneration.coastal")}</MenuItem>
                                <MenuItem key={5} value={"Traditional"}>{t("roomImageGeneration.traditional")}</MenuItem>
                                <MenuItem key={6} value={"Bohemian"}>{t("roomImageGeneration.bohemian")}</MenuItem>
                                <MenuItem key={7} value={"Art Deco"}>{t("roomImageGeneration.artDeco")}</MenuItem>
                                <MenuItem key={8} value={"Contemporary"}>{t("roomImageGeneration.contemporary")}</MenuItem>
                                <MenuItem key={9} value={"Modern"}>{t("roomImageGeneration.modern")}</MenuItem>
                                <MenuItem key={10} value={"Midcentury Modern"}>{t("roomImageGeneration.midcenturyModern")}</MenuItem>
                                <MenuItem key={11} value={"Country"}>{t("roomImageGeneration.country")}</MenuItem>
                                <MenuItem key={12} value={"Shabby Chic"}>{t("roomImageGeneration.shabbyChic")}</MenuItem>
                                <MenuItem key={13} value={"Modern Farmhouse"}>{t("roomImageGeneration.modernFarmhouse")}</MenuItem>
                                <MenuItem key={14} value={"Americana"}>{t("roomImageGeneration.americana")}</MenuItem>
                                <MenuItem key={15} value={"French Country"}>{t("roomImageGeneration.frenchCountry")}</MenuItem>
                                <MenuItem key={16} value={"Transitional"}>{t("roomImageGeneration.transitional")}</MenuItem>
                                <MenuItem key={17} value={"Hollywood Regency"}>{t("roomImageGeneration.hollywoodRegency")}</MenuItem>
                                <MenuItem key={18} value={"Chinoiserie"}>{t("roomImageGeneration.chinoiserie")}</MenuItem>
                                <MenuItem key={19} value={"Mediterranean"}>{t("roomImageGeneration.mediterranean")}</MenuItem>
                                <MenuItem key={20} value={"Tropical"}>{t("roomImageGeneration.tropical")}</MenuItem>
                                <MenuItem key={21} value={"Minimalist"}>{t("roomImageGeneration.minimalist")}</MenuItem>
                                <MenuItem key={22} value={"Maximalist"}>{t("roomImageGeneration.maximalist")}</MenuItem>
                                <MenuItem key={23} value={"Rustic"}>{t("roomImageGeneration.rustic")}</MenuItem>
                                <MenuItem key={24} value={"Romantic"}>{t("roomImageGeneration.romantic")}</MenuItem>
                                <MenuItem key={25} value={"Asian"}>{t("roomImageGeneration.asian")}</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                }
                {category === "commercial" && <div className="row">
                    <div className="col-md-6">
                        <label className="form-label bold-700 mb-3 padd-00" htmlFor="selectTypeOpt">{t("roomImageGeneration.selectPropertyType")}</label>
                        <FormControl fullWidth>
                            <Select
                                className="custom-select mb-4"
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectRoom}
                                onChange={handleSelectChangeRoom}
                                sx={{
                                    border: "1px solid #BEBDBD",

                                }}>
                                <MenuItem key={0} value="" disabled>
                                    {t("propertiesPage.select")}
                                </MenuItem>
                                <MenuItem key={1} value="executive office" >Office - Executive Office</MenuItem>
                                <MenuItem key={2} value="open workspace" >Office -Open Workspace</MenuItem>
                                <MenuItem key={3} value="meeting room" >Office - Meeting Room</MenuItem>
                                <MenuItem key={4} value="conference room" >Office - Conference Room</MenuItem>
                                <MenuItem key={5} value="reception lobby" >Office - Reception Lobby</MenuItem>
                                <MenuItem key={6} value="boardroom" >Office - Boardroom</MenuItem>
                                <MenuItem key={7} value="breakout lounge" >Office - Breakout Lounge</MenuItem>
                                <MenuItem key={8} value="fashion boutique" >Shop - Fashion Boutique</MenuItem>
                                <MenuItem key={9} value="cosmetics shop" >Shop - Cosmetics Shop</MenuItem>
                                <MenuItem key={10} value="electronics store" >Shop - Electronics Store</MenuItem>
                                <MenuItem key={11} value="shoe store" >Shop - Shoe Store</MenuItem>
                                <MenuItem key={12} value="jewelry store" >Shop - Jewelry Store</MenuItem>
                                <MenuItem key={13} value="modern café" >Coffee Shop - Modern Coffee</MenuItem>
                                <MenuItem key={14} value="coffee roastery" >Coffee Shop - Coffee Roastery</MenuItem>
                                <MenuItem key={15} value="tea lounge" >Coffee Shop - Tea Lounge</MenuItem>
                                <MenuItem key={16} value="bakery café" >Coffee Shop - Bakery Coffee</MenuItem>
                                <MenuItem key={17} value="espresso bar" >Coffee Shop - Espresso Bar</MenuItem>
                                <MenuItem key={18} value="book café" >Coffee Shop - Book Coffee</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label bold-700 mb-3 padd-00" htmlFor="selectTypeOpt">{t("roomImageGeneration.selectFurnishingStyle")}</label>
                        <FormControl fullWidth>
                            <Select
                                className="custom-select mb-4 "
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectStyle}
                                onChange={handleSelectChangeStyle}
                                sx={{
                                    border: "1px solid #BEBDBD",

                                }}>
                                <MenuItem key={0} value="" disabled>
                                    {t("propertiesPage.select")}
                                </MenuItem>
                                <MenuItem key={1} value="modern minimalist">Modern Minimalist</MenuItem>
                                <MenuItem key={2} value="contemporary corporate">Contemporary Corporate</MenuItem>
                                <MenuItem key={3} value="scandinavian workstyle">Scandinavian Workstyle</MenuItem>
                                <MenuItem key={4} value="luxury executive">Luxury Executive</MenuItem>
                                <MenuItem key={5} value="biophilic natural">Biophilic Natural</MenuItem>
                                <MenuItem key={6} value="mid-century modern">Mid-Century Modern</MenuItem>
                                <MenuItem key={7} value="japandi">Japandi</MenuItem>
                                <MenuItem key={8} value="artistic creative">Artistic Creative</MenuItem>
                                <MenuItem key={9} value="coastal relaxed">Coastal Relaxed</MenuItem>
                                <MenuItem key={10} value="classic heritage">Classic Heritage</MenuItem>
                                <MenuItem key={11} value="eco-sustainable">Eco-Sustainable</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                }

                <div className="d-flex justify-content-end padd-00">
                    <button type="button"
                        disabled={!selectStyle || !selectRoom || isCheckingFurniture || isRemovingFurniture}
                        className={`room-staging-btn-generate-action ${selectStyle && selectRoom && !isCheckingFurniture && !isRemovingFurniture
                            ? 'room-staging-btn-generate-action-active'
                            : 'room-staging-btn-generate-action-disabled'
                            }`} onClick={generate}>{t("roomImageGeneration.generate")}</button>
                </div>
            </div >
        </div>
    )
}
export default RoomStaging;